<template>
  <!DOCTYPE html><html>
    <head></head>
      <body style="font-family: 'Montserrat', sans-serif; text-align: center; color: #000000 !important;">
        <pre style="padding: 4px; font-family: 'Montserrat', sans-serif; font-size: 50px; font-weight:900; text-align: center;">LISTA ABORDAJE</pre>
        <table style="border-collapse: collapse; width: 100%; font-size: 32px; text-align: left;">  
              <tr>    
                  <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000; width: 40%;"></th>
                  <th style="padding: 2px; padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: white; color: #000000; width: 60%;"></th> 
              </tr> 
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">RUTA:</td>
                  <td style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.nombre_ruta}}</td>  
              </tr>   
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">SUCURSAL:</td>
                  <td style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{user.agencia_activa}}</td>  
              </tr> 
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">FECHA:</td>
                  <td style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.fecha_salida | moment('dddd, DD-MM-YYYY')}}</td>  
              </tr>   
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">HORA:</td>
                  <td style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.fecha_salida | moment('HH:mm')}} HRS</td>  
              </tr>  
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">No AUTOBUS:</td>
                  <td v-if="corrida.numero_economico != null" style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.numero_economico}}</td>  
              </tr>
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">CONDUCTOR 1:</td>
                  <td v-if="corrida.nombre_operador1 != ' '" style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.nombre_operador1}}</td>  
              </tr>
              <tr>    
                  <td style="padding: 2px; font-weight:800; font-size: 26px;">CONDUCTOR 2:</td>
                  <td v-if="corrida.nombre_operador2 != ' '" style="padding: 2px; text-transform: uppercase; font-size: 28px; font-weight:800;">{{corrida.nombre_operador2}} </td>  
              </tr>
          </table>
        <table style="border-collapse: collapse; width: 99%; font-weight:700; text-align: center;">  
          <tr>    
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>  
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>  
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>  
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>
            <th style="padding-top: 6px; padding-bottom: 6px; text-align: left; background-color: #000000; color: white;"></th>   
          </tr>  
          <tr>    
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 7%;">No Ato</th>
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 10%;">No Pase</th>
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 50%;">Nombre Pasajero</th> 
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 13%;">Sube</th> 
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 13%;">Baja</th>  
            <th style="font-size: 18px; padding-top: 4px; padding-bottom: 4px; text-align: center; background-color: white; width: 7%;"></th>  
          </tr>  
          <tr v-for="item in lista" :key="item">    
            <td style="padding: 1px; font-size: 17px; font-weight:700; text-transform: uppercase;">{{item.attributes.numero}}</td>
            <td style="padding: 1px; font-size: 17px; font-weight:700; text-transform: uppercase;">
              <div v-if="item.attributes.boleto_pasajero">
                  <div v-for="boleto in item.attributes.boleto_pasajero" :key="boleto_pasajero">
                    <span>{{boleto}}</span>
                  </div>
              </div>
            </td>
            <td style="padding: 1px; font-size: 21px; font-weight:700; text-transform: uppercase;">
              <div v-if="item.attributes.pasajeros">
                  <div v-for="pasajero in item.attributes.pasajeros" :key="pasajero">
                    <span>{{pasajero}}</span>
                  </div>
              </div>
            </td>
            <td style="padding: 1px; font-size: 17px; font-weight:700; text-transform: uppercase;">
              <div v-if="item.attributes.sube">
                  <div v-for="sube in item.attributes.sube" :key="pasajero">
                    <span>{{sube}}</span>
                  </div>
              </div>
            </td>
            <td style="padding: 1px; font-size: 17px; font-weight:700; text-transform: uppercase;">
              <div v-if="item.attributes.baja">
                  <div v-for="baja in item.attributes.baja" :key="pasajero">
                    <span>{{baja}}</span>
                  </div>
              </div>
            </td>
            <td></td>
          </tr>     
        </table>
      </body>
    </html>
</template>
<script>
export default {
props: {
  lista: {required: false},
  user: {required: false},
  corrida: {required: false},
},
data() {
    return {
     
    };
  },
}
</script>
<style scoped> 
</style>